import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import LanternLabs from './components/LanternLabs';
import MediaPage from './components/MediaPage';
import ContactPage from './components/ContactPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import FooterSectionV2 from './components/FooterSectionV2';
import CookiePopup from './components/CookiePopup';
import { Analytics } from "@vercel/analytics/react"

function App() {
    useEffect(() => {
        const DESIGN_WIDTH = 1920;
        const MIN_DESKTOP = 1025;

        const updateScale = () => {
            const vw = window.innerWidth;
            if (vw >= MIN_DESKTOP && vw < DESIGN_WIDTH) {
                // Smaller desktop/laptop: scale proportionally
                const factor = vw / DESIGN_WIDTH;
                document.documentElement.style.zoom = factor.toString();
                document.documentElement.style.setProperty('--zoom-factor', factor.toString());
            } else {
                // Mobile/tablet (<=1024) or large screens (>=1920): no zoom
                document.documentElement.style.zoom = '1';
                document.documentElement.style.setProperty('--zoom-factor', '1');
            }
        };

        // Initial zoom already set by inline script in index.html;
        // attach resize listener for window changes.
        window.addEventListener('resize', updateScale);
        return () => window.removeEventListener('resize', updateScale);
    }, []);

    return (
        <Router>
            <div className="App">
                <ScrollToTop />
                <Header />
                <Routes>
                    <Route path="/" element={<LanternLabs />} />
                    <Route path="/media" element={<MediaPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                </Routes>
                <Analytics />
                <CookiePopup />
            </div>
            <FooterSectionV2 />
        </Router>
    );
}

export default App;
